<div
  class="card-item-list-item"
  [class.completed]="card().completed"
  (click)="cardClick.emit(card())"
  (keydown.enter)="cardClick.emit(card())"
  tabindex="0"
  role="button"
  [attr.aria-label]="'Open ' + card().header"
>
  <div class="card-item-list-item-inner">
    <div class="card-item-list-item-image">
      <ptl-card-image [src]="card().image" [alt]="card().header" [cardIndex]="cardIndex()"></ptl-card-image>
    </div>

    <div class="card-item-list-item-content">
      <h3 class="card-item-list-item-title subtitle6">{{ card().header }}</h3>

      @if (card().blurb) {
        <div class="card-item-list-item-description" [innerHTML]="card().blurb"></div>
      }
    </div>

    <div class="progress-spinner-container" [class.disabled]="!card()?.completed">
      <mat-progress-spinner
        class="progress-spinner"
        diameter="56"
        [value]="card()?.completed ? 100 : 0"
        mode="determinate"
        aria-label="Task progress"
      ></mat-progress-spinner>

      <div class="percent-text body-s semibold">
        {{ card()?.completed ? '100%' : '0%' }}
      </div>
    </div>
  </div>
</div>
